import React from 'react';
import ImageTestimonialsGallery from '@/components/ImageTestimonialsGallery.jsx';

const base = '/TESTIMONIOS WEB CODIGO CARPETAS/TESTOMONIOS HOME';
const desktopImages = [1, 2, 3, 4].map((number) => `${base}/DESKTOP/${number}.webp`);
const mobileImages = [1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12].map((number) => `${base}/MOBILE/${number}.webp`);

function TestimonialsSection() {
  return (
    <ImageTestimonialsGallery
      title="Las familias dicen..."
      subtitle="Ya son más de 25.000 familias las que confiaron en nuestros cursos"
      desktopImages={desktopImages}
      mobileImages={mobileImages}
      sectionClassName="section-padding bg-background"
      imageAlt="Testimonio real de familias que transformaron sus noches"
    />
  );
}

export default TestimonialsSection;
